var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgProfiles = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 176.25 176.25"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Profiles_svg__cls-1{fill:none;stroke:currentColor;stroke-linecap:square;stroke-miterlimit:10;stroke-width:11.25px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Profiles_svg__Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Profiles_svg___\\xCE\\xD3\\xC8_1",
  "data-name": "\\u2014\\xCE\\xD3\\xC8_1"
}, /*#__PURE__*/React.createElement("circle", {
  className: "Profiles_svg__cls-1",
  cx: 88.13,
  cy: 50.63,
  r: 45
}), /*#__PURE__*/React.createElement("path", {
  className: "Profiles_svg__cls-1",
  d: "M5.62 170.62c0-41.45 21.91-75 67.5-75h30c45.6 0 67.5 33.55 67.5 75"
})))));
export default SvgProfiles;